import { toast } from 'sonner';
import { API } from '@/lib/api';

export const fmt = (v) => new Intl.NumberFormat('id-ID').format(v || 0);

export function cleanParams(params) {
  const o = {};
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') o[k] = v;
  });
  return o;
}

export function monthRange() {
  const d = new Date();
  const end = d.toISOString().slice(0, 10);
  const s = new Date(d.getFullYear(), d.getMonth(), 1).toISOString().slice(0, 10);
  return { start: s, end };
}

export async function downloadCsv(path, params, filename) {
  try {
    const token = localStorage.getItem('token');
    const q = new URLSearchParams({ ...cleanParams(params), format: 'csv' });
    const url = `${API}${path}?${q}`;
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error('Export gagal');
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch {
    toast.error('Gagal unduh CSV');
  }
}

export function toastExportNeedsLoad() {
  toast.error('Klik Muat data terlebih dahulu — export mengikuti data di layar.');
}

export async function downloadPdf(path, params, filename) {
  try {
    const token = localStorage.getItem('token');
    const q = new URLSearchParams({ ...cleanParams(params), format: 'pdf' });
    const url = `${API}${path}?${q}`;
    const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) throw new Error('Export gagal');
    const blob = await r.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;
    a.click();
    URL.revokeObjectURL(a.href);
  } catch {
    toast.error('Gagal unduh PDF');
  }
}
